import { Link, Navigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const LoginCard = ({ title = "Client Portal", sub = "Sign in to view your appointments, Academy registrations and intake status.", path = "/portal", children }) => {
  const { login } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-28 pb-20 relative overflow-hidden" data-testid="login-card">
      <div className="absolute w-[520px] h-[520px] rounded-full bg-[#5D2E8C]/35 blur-[140px]" />
      <div className="relative lux-card max-w-md w-full p-10 md:p-12">
        <img src="/images/logo-b2r-gold.png" alt="B2R LLC logo" className="h-16 w-auto" />
        <h1 className="mt-8 text-4xl sm:text-5xl font-medium">{title}</h1>
        <p className="mt-4 text-white/65 text-sm leading-relaxed">{sub}</p>
        <button onClick={() => login(path)} className="btn-gold w-full mt-10" data-testid="google-login-button">Continue with Google</button>
        <p className="mt-6 flex items-center gap-2 text-xs text-white/45"><ShieldCheck className="w-4 h-4 text-[#D4AF37]" /> Secure sign-in. We never see your Google password.</p>
        {children ? (
          <>
            <div className="my-8 flex items-center gap-4 text-[11px] tracking-[0.2em] uppercase text-white/40"><span className="flex-1 h-px bg-white/10" />or use email<span className="flex-1 h-px bg-white/10" /></div>
            {children}
          </>
        ) : (
          <Link to="/admin" className="mt-6 block py-2 text-xs text-white/45 hover:text-[#D4AF37] transition-colors" data-testid="login-admin-link">B2R admin? Sign in here</Link>
        )}
      </div>
    </div>
  );
};

export default function Login() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen" />;
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
  return <LoginCard />;
}
